import { Badge } from '@/components/ui/badge';
import type { SandboxState } from '@/models/sandbox';

interface StateBadgeProps {
  state: SandboxState;
  size?: 'default' | 'sm';
  publishStatus?: SandboxState | null;
}

const stateConfig: Record<
  SandboxState,
  { label: string; variant: 'warning' | 'success' }
> = {
  dirty: { label: 'Dirty', variant: 'warning' },
  published: { label: 'Published', variant: 'success' },
};

export const StateBadge = ({ state, size = 'default' }: StateBadgeProps) => {
  const config = stateConfig[state];
  return (
    <Badge
      variant={config.variant}
      className={size === 'sm' ? 'px-1.5 py-0 text-[10px]' : undefined}
    >
      {config.label}
    </Badge>
  );
};
